import { Card, CardContent, CardHeader, Grid } from "@material-ui/core";
import { CvsInfoArea } from "../../order/CvsInfoArea";
import React, { FC } from "react";
import { toStringCvsStore } from "lib/order_util";
import BankInfoArea from "components/front/order/BankInfoArea";
import { OrderPayment } from "interfaces/front/page/mypage/supportPanel";

export const OrderPaymentArea: FC<{ payment: OrderPayment }> = ({ payment }) => {
  return (
    <>
      {payment.payment_method === "cvs" && (
        <>
          <Card variant={"outlined"} style={{ margin: "10px 0" }}>
            <CardHeader disableTypography title="コンビニでお支払い" style={{ fontSize: "16px" }} />
            <CardContent>
              <Grid container alignItems={"center"}>
                <Grid item style={{ marginRight: "20px" }}>
                  <img
                    alt={toStringCvsStore(payment.cvs_detail!!.cvs_type)}
                    src={`/img/cvs/${payment.cvs_detail!!.cvs_type}.png`}
                    width="50px"
                  />
                </Grid>
                <Grid item style={{ marginRight: "20px" }}>
                  <span>{toStringCvsStore(payment.cvs_detail!!.cvs_type)}</span>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <CvsInfoArea payment={payment} withStore={false} />
        </>
      )}
      {payment.payment_method === "credit_card" && (
        <Card variant={"outlined"} style={{ margin: "10px 0" }}>
          <CardHeader disableTypography title="クレジットカードでお支払い" style={{ fontSize: "16px" }} />
        </Card>
      )}
      {payment.payment_method === "bank" && (
        <>
          <Card variant="outlined" style={{ margin: "10px 0" }}>
            <CardHeader disableTypography title="銀行振込でお支払い" style={{ fontSize: "16px" }} />
          </Card>
          <BankInfoArea bankDetail={payment.bank_detail} />
        </>
      )}
      {payment.payment_method === "cash" && (
        <Card variant="outlined" style={{ margin: "10px 0" }}>
          <CardHeader disableTypography title="現金でお支払い" style={{ fontSize: "16px" }} />
          <CardContent>
            <div>※お支払いは窓口にて現金でお支払いいただきます。</div>
          </CardContent>
        </Card>
      )}
    </>
  );
};
